import {HelpPreload} from '@components/common/help/help'
import {SVGPreload} from '@components/common/svg-preload/svg-preload'
import React from 'react'

export const Preload = () => {
  return (
    <>
      <HelpPreload />
      <SVGPreload
        img={[
          'main-menu/toggle/close',
          'main-menu/toggle/close-notify',
          'main-menu/toggle/open',
          'main-menu/toggle/open-notify',
          'group-chat/menu/add-group',
          'main-menu/v2/user-list',
          'main-menu/v2/my-tasks',
          'main-menu/v2/others-tasks',
          'main-menu/v2/partner',
          'main-menu/v2/projects',
          'main-menu/v2/help',
          'main-menu/v2/statistics',
          'main-menu/v2/billing'
        ]}
        suffixes={['-hover']}
      />
      <SVGPreload img={['main-menu/v2/settings']} />
      <SVGPreload
        img={[
          'menu/menu-hover',
          'menu/menu-active',
          'top-bar/close-big',
          'top-bar/close-big-hover',
          'top-bar/close-big-pressed',

          'chat/attach',
          'chat/attach-hover',
          'chat/attach-active',
          'chat/send',
          'chat/send-hover',
          'chat/send-active'
        ]}
        suffixes={[]}
      />
      <SVGPreload
        img={[
          'description/descr-bold',
          'description/descr-italic',
          'description/descr-underline',
          'description/descr-strike',
          'description/descr-bullets',
          'description/descr-numbered',
          'description/descr-attach'
        ]}
      />
    </>
  )
}
